module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "instagram"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "instahead"
  }, [_vm._v("Dinge und Geschichten von anderen")]), _vm._v(" "), _c('items', {
    staticClass: "instafeed grid wrapper",
    attrs: {
      "items": _vm.items
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cta"
  }, [_c('article', [_c('h4', [_vm._v("#liebdinge")]), _vm._v(" "), _c('i', {
    staticClass: "heart"
  }), _vm._v(" "), _c('h2', [_vm._v("Teile dein Liebding auf Instagram")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-602eac1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Instagram.vue
// module id = 315
// module chunks = 0